import * as Icon from "react-feather";

export interface FeatherIconType {
  iconName: keyof typeof Icon;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const FeatherIcons: React.FC<FeatherIconType> = ({
  iconName,
  className,
  onClick,
  style,
}) => {
  const IconComp = Icon[iconName];
  return (
    <IconComp
      width={15}
      height={15}
      className={className}
      onClick={onClick}
      style={style}
    />
  );
};

export default FeatherIcons;
